const TOKEN_KEY = 'boat_admin_token'
const USER_KEY = 'boat_admin_user'
const PERMS_KEY = 'boat_admin_permissions'
const REMEMBER_KEY = 'boat_admin_remember'

export function getToken() {
  return localStorage.getItem(TOKEN_KEY)
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token)
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY)
}

export function getUser() {
  const raw = localStorage.getItem(USER_KEY)
  try {
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function setUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user))
}

export function removeUser() {
  localStorage.removeItem(USER_KEY)
}

export function getPermissions() {
  const raw = localStorage.getItem(PERMS_KEY)
  try {
    return raw ? JSON.parse(raw) : []
  } catch {
    return []
  }
}

export function setPermissions(perms) {
  localStorage.setItem(PERMS_KEY, JSON.stringify(perms || []))
}

export function removePermissions() {
  localStorage.removeItem(PERMS_KEY)
}

export function getRemember() {
  const raw = localStorage.getItem(REMEMBER_KEY)
  try {
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export function setRemember(credentials) {
  localStorage.setItem(REMEMBER_KEY, JSON.stringify(credentials))
}

export function removeRemember() {
  localStorage.removeItem(REMEMBER_KEY)
}
